var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import { ReactComponent as ArrowupIcon } from "../../icons/arrowupicon.svg";
import { ReactComponent as DropdownIcon } from "../../icons/dropdownn.svg";
import * as Icons from "../../icons";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
function Icon(_a) {
    var { icon } = _a, props = __rest(_a, ["icon"]);
    const Icon = Icons[icon];
    return Icon ? _jsx(Icon, Object.assign({}, props)) : _jsx("div", { className: "px-6", children: "I" });
}
const MENU = ({ route, isExpanded }) => {
    var _a, _b;
    const [subRoute, setSubRoute] = React.useState(false);
    const [subRouteIndex, setSubRouteIndex] = React.useState(0);
    const { collapsed } = useContext(AuthContext);
    const { t } = useTranslation();
    const { theme } = useTheme();
    const [configFlags, setConfigFlags] = React.useState([]);
    const [visibilityFlags, setVisibilityFlags] = React.useState([]);
    const [permissionFlags, setPermissionFlags] = React.useState([]);
    useEffect(() => {
        setSubRoute(isExpanded);
    }, [isExpanded]);
    const showSubRoutes = () => {
        setSubRoute(!subRoute);
    };
    const { globalConfig } = useContext(AuthContext);
    const hexToRgb = (hex) => {
        // Remove the leading '#' if present
        hex = hex === null || hex === void 0 ? void 0 : hex.replace(/^#/, "");
        // Parse the hex value into its RGB components
        let bigint = parseInt(hex, 16);
        let r = (bigint >> 16) & 255;
        let g = (bigint >> 8) & 255;
        let b = bigint & 255;
        return `${r}, ${g}, ${b}`;
    };
    const loadFlags = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const childModule = yield import("adrinWebApp/FlagUtils");
            setConfigFlags(childModule.configFlag || []);
            setVisibilityFlags(childModule.visibilityFlag || []);
            setPermissionFlags(childModule.permissionFlag || []);
        }
        catch (error) {
            console.error("Error loading flags:", error);
            setConfigFlags([]);
            setVisibilityFlags([]);
            setPermissionFlags([]);
        }
    });
    useEffect(() => {
        loadFlags();
    }, []);
    // Check if parent route should be hidden - use permissionFlags array
    if (permissionFlags.length > 0 && permissionFlags.includes(route.name)) {
        const moduleValidationConfig = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.find((config) => config.key === "modulerequired830");
        if ((moduleValidationConfig === null || moduleValidationConfig === void 0 ? void 0 : moduleValidationConfig.value) === "false") {
            return null; // Hide the entire menu item
        }
    }
    return (_jsxs("div", { className: `flex flex-col ${subRoute ? `${theme.sideMenuColor}` : null}`, children: [_jsx("div", { className: `flex-row cursor-pointer `, style: { color: theme.menuTextColor }, onClick: route.subRoutes && showSubRoutes, children: _jsxs(NavLink, { onClick: () => {
                        setSubRouteIndex(0);
                    }, to: (route === null || route === void 0 ? void 0 : route.subRoutes) && ((_a = route === null || route === void 0 ? void 0 : route.subRoutes) === null || _a === void 0 ? void 0 : _a.length) > 0
                        ? route.subRoutes[subRouteIndex].path
                        : route.path, style: ({ isActive }) => isActive || isExpanded
                        ? {
                            color: theme.menuTextColorOnHover,
                            // background: `${
                            //   !route.subRoutes
                            //     ? `rgba(${hexToRgb(theme?.menuTextColorOnHover)}, 0.05)`
                            //     : null
                            background: `rgba(${hexToRgb("#FFFFFF")}, 0.05)`,
                        }
                        : { color: theme.menuTextColor }, className: "flex py-[10px]", children: [_jsx(Icon, { className: "ml-[21px] mr-[15px] w-[14px] h-auto", icon: route.icon }), !collapsed && (_jsxs(_Fragment, { children: [_jsx("h1", { className: "text-sidebar pt-0.5 text-wrap w-28 cursor-pointer", children: t(`${route.name}`) }), route.subRoutes && subRoute ? (_jsx("div", { className: "flex flex-row-reverse flex-grow self-center mx-5", children: _jsx(ArrowupIcon, { className: "w-[10px] h-[6px]" }) })) : route.subRoutes ? (_jsx("div", { className: "flex flex-row-reverse flex-grow self-center mx-5", children: _jsx(DropdownIcon, { className: "w-[10px] h-[6px]" }) })) : null] }))] }) }), (route === null || route === void 0 ? void 0 : route.subRoutes) &&
                subRoute &&
                ((_b = route === null || route === void 0 ? void 0 : route.subRoutes) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                !collapsed
                ? route.subRoutes.map((subRoute, i) => {
                    // Check if deviceValidation is false and hide Device List and Device Type
                    const deviceValidationConfig = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.find((config) => config.key === "deviceValidation");
                    const shouldHideDeviceRoutes = (deviceValidationConfig === null || deviceValidationConfig === void 0 ? void 0 : deviceValidationConfig.value) === "false" &&
                        (subRoute.name === "Device List" ||
                            subRoute.name === "Device Type");
                    if (shouldHideDeviceRoutes) {
                        return null;
                    }
                    // Check modulerequired830 - use visibilityFlags array
                    if (visibilityFlags.length > 0 &&
                        visibilityFlags.includes(subRoute.name)) {
                        const moduleValidationConfig = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.find((config) => config.key === "modulerequired830");
                        if ((moduleValidationConfig === null || moduleValidationConfig === void 0 ? void 0 : moduleValidationConfig.value) === "false") {
                            return null;
                        }
                    }
                    // route.path+subRoute.path
                    return (_jsxs("div", { className: `py-1 ${route.subRoutes.length - 1 === i ? "pb-3" : null}`, style: {
                            backgroundColor: isExpanded
                                ? `rgba(${hexToRgb("#FFFFFF")}, 0.05)`
                                : null,
                        }, children: [_jsx(NavLink, { onClick: () => setSubRouteIndex(i), to: subRoute.path, style: ({ isActive }) => isActive
                                    ? { color: theme.menuTextColorOnHover }
                                    : { color: theme.menuTextColor }, children: _jsx("h1", { className: `text-sidebar ltr:ml-[52px] rtl:mr-[52px] cursor-pointer ${subRoute ? "inline-block" : "hidden"}`, children: t(`${subRoute.name}`) }) }, `${subRoute.name}${i}`), _jsx(Routes, { children: _jsx(Route, { path: subRoute.path, exact: route.exact }) })] }, `${subRoute.name}${i}`));
                })
                : null] }));
};
export default MENU;
